
<ngx-stripe-payment
  [clientSecret]="paymentIntent.client_secret"
  [elementsOptions]="elementsOptions"
  [options]="paymentOptions"
  [appearance]="appearance"
  (ready)="isLoading = false"
  (change)="inputChange($event);"
  >
</ngx-stripe-payment>

@if (!isLoading) {
  <mat-checkbox [(ngModel)]="savePaymentMethod" class="save-card-details">Save my card details for future use. If you select this option then all future invoices will be paid automatically. Except for current outstanding invoices.</mat-checkbox>
}

@if (!isLoading) {
  <div class="footer">
    <div class="safe-secure-container">
      <mat-icon fontIcon="lock" class="lock-icon"></mat-icon>
      <span>Guaranteed  <b>safe &amp; secure</b> payment</span>
      <span class="powered-by-stripe-container">
        <span class="powered-by">Powered by </span>
        <span class="stripe">stripe</span>
      </span>
    </div>
    <div class="button-container" >
      <button matButton="tonal" (click)="pay()" [disabled]="!isValid || paying || isLoading">PAY</button>
    </div>
  </div>
}


